import {
  Component,
  Input,
  OnInit,
  ChangeDetectorRef
} from '@angular/core';
import {
  FormGroup,
  FormBuilder,
  Validators,
} from '@angular/forms';


import { DynamicFormConfig } from './dynamic-form-config.interface';
import { ILastDataBundle, ILastDataForm } from '../../core/interfaces/bundle/ILastData';

@Component({
  exportAs: 'dynamicForm',
  selector: 'dynamic-form',
  templateUrl: './dynamic-form.component.html',
  styleUrls: ['./dynamic-form.component.scss']
})
export class DynamicFormComponent implements OnInit {

  public _formConfig: DynamicFormConfig;

  @Input()
  set formConfig(form: DynamicFormConfig) {
    this._formConfig = form;
  }

  get formConfig(): DynamicFormConfig {
    return this._formConfig;
  }

  public form: FormGroup;

  get value(): ILastDataForm | any {
    return this.form.value;
  }

  constructor(private fb: FormBuilder, private cdRef: ChangeDetectorRef) { }

  ngOnInit(): void {
    this.form = this.createControl();
  }

  setValues(newFormValues: ILastDataBundle | any): void {
    this.form.patchValue(newFormValues);
  }

  createControl(): FormGroup {
    const group = this.fb.group({});
    this._formConfig.fields.forEach((field: any) => {
      const control = this.fb.control(
        { value: field.value, disabled: field.disabled },
        this.bindValidations(field.validations || [])
      );
      group.addControl(field.name, control);
    });

    return group;
  }

  bindValidations(validations: any): Validators | null {
    if (validations.length > 0) {
      const validList: any[] = [];
      validations.forEach((valid: any) => {
        validList.push(valid.validator);
      });
      return Validators.compose(validList);
    }
    return null;
  }

  validateAllFormFields(formGroup: FormGroup): void {
    for (const [field] of Object.keys(formGroup.controls)) {
      const control: any = formGroup.get(field);
      control.markAsTouched({ onlySelf: true });
    }
  }

}
